// React
import React from 'react';
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Label,
  CardBody,
  CardFooter,
} from 'reactstrap';

// Components
import { PageWrapper } from '../../containers/componentsInjection';

const ExportPharmaPage = ({ validation, history }) => {
  return (
    <PageWrapper title="Exportação Rede de Farmácias">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={6} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período de venda
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="startPeriod"
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          value={validation.values.startPeriod}
                          invalid={
                            !!(
                              validation.touched.startPeriod &&
                              validation.errors.startPeriod
                            )
                          }
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="endPeriod"
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          value={validation.values.endPeriod}
                          invalid={
                            !!(
                              validation.touched.endPeriod &&
                              validation.errors.endPeriod
                            )
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex btn-link justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Exportar para Excel
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
export default ExportPharmaPage;
